import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import CurrencyService from '@/service/CurrencyService';

export const useCurrencyStore = defineStore('currencyStore', {
  state: () => ({
    listCurrency: [],
    isLoading: false,
    isUpdate: false
  }),
  getters: {
    selectListCurrency: (state) => state.listCurrency,
    selectIsLoading: (state) => state.isLoading,
    selectIsUpdate: (state) => state.isUpdate
  },
  actions: {
    async getListCurrency() {
      const currencyService = new CurrencyService();
      try {
        const res = await currencyService.getCurrency();
        this.updateListCurrency(res.data);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async updateCurrency(payload) {
      this.isLoading = true;
      const currencyService = new CurrencyService();
      try {
        const res = await currencyService.updateCurrency(payload);
        if (res) {
          this.isUpdate = true;
          this.isLoading = false;
          this.updateListCurrency(res.data);
        }
      } catch (e) {
        this.isUpdate = false;
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    updateListCurrency(payload) {
      this.listCurrency = payload;
    }
  }
});
